import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE__components_Form_Error_Error_js_90bd6a29__ from "../../components/Form/Error/Error.js";
import * as __WEBPACK_EXTERNAL_MODULE__Field_FieldContext_js_2aa6688b__ from "../Field/FieldContext.js";
function ErrorMessage() {
    const { hasError, errorMessage } = (0, __WEBPACK_EXTERNAL_MODULE__Field_FieldContext_js_2aa6688b__.useFieldContext)();
    if (!hasError || !errorMessage) return null;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__components_Form_Error_Error_js_90bd6a29__["default"], {
        errorMessage: errorMessage
    });
}
const Error_rslib_entry_ = ErrorMessage;
export { Error_rslib_entry_ as default };

//# sourceMappingURL=Error.js.map